import { ChangeDetectionStrategy, Component, Input, Optional, ViewEncapsulation } from '@angular/core';

import { UiIconsList } from 'ui-icons';

import { UiPlatformStatusMarkerStateEnum } from './enums/status-marker.enums';
import { UiPlatformStatusMarkerState } from './models/status-marker.model';

import { UiPlatformMenuItem, UiPlatformMenuItems } from '../menu/menu.model';

@Component({
  selector: 'ui-platform-status-marker',
  templateUrl: './status-marker.component.html',
  styleUrl: './status-marker.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class UiPlatformStatusMarkerComponent {
  @Optional() @Input() disabled = false;
  @Input() menuItems: UiPlatformMenuItems = [];

  private _status!: UiPlatformStatusMarkerState;

  public get status(): UiPlatformStatusMarkerState {
    return this._status;
  }

  @Input() set status(value: UiPlatformStatusMarkerState) {
    this._status = value;
    this._setPropertiesBasedOnStatus();
  }

  private _icon!: UiIconsList;

  public get icon(): UiIconsList {
    return this._icon;
  }

  public get btnStatusClass(): string {
    return `btn-${this._status}`;
  }

  public get label(): string {
    return `ui-platform.status-marker.${this._status}.label`;
  }

  constructor() {}

  menuItemSelected(item: UiPlatformMenuItem) {
    if (item.callback) {
      item.callback();
    }
  }

  private _setPropertiesBasedOnStatus(): void {
    switch (this._status) {
      case UiPlatformStatusMarkerStateEnum.waiting:
        this._icon = 'chevron-right-in-circle';
        break;
      case UiPlatformStatusMarkerStateEnum.inProgress:
        this._icon = 'chevron-right-in-circle';
        break;
      case UiPlatformStatusMarkerStateEnum.done:
        this._icon = 'check-in-circle';
        break;
      case UiPlatformStatusMarkerStateEnum.verification:
        this._icon = 'arrow-up-in-circle';
        break;
      case UiPlatformStatusMarkerStateEnum.interactionNeeded:
        this._icon = 'interaction-needed';
        break;
      case UiPlatformStatusMarkerStateEnum.verified:
        this._icon = 'check-in-circle';
        break;
      case UiPlatformStatusMarkerStateEnum.ready:
        this._icon = 'check-in-circle';
        break;
      case UiPlatformStatusMarkerStateEnum.notReady:
        this._icon = 'interaction-needed';
        break;
      default:
        break;
    }
  }
}
